export const REGION_CANDIDATES = [
    { label: '東京のみ', value: 1 },
    { label: '関東エリア', value: 2 },
    { label: '関西エリア', value: 3 },
    { label: 'その他エリア', value: 4 },
];
export const ACCEPTANCE_CANDIDATES = [
    { label: '今すぐ実施可能', value: 1 },
    { label: '時期要相談', value: 0 },
];
export const ORDER_CANDIDATES = [
    { label: '人気順', value: 'popular' },
    { label: '新着順', value: 'new' },
    { label: 'マッチ順', value: 'match' },
];
